<!-- languageSelector -->
<template>
  <div class="language">
    <div class="language__current">
      <span>{{ getCurrentLanguage }}</span>
      <i class="icon icon-previous"></i>
    </div>
    <div class="language__list">
      <div
        v-for="(language, code) in languages"
        :key="code"
        class="language__item"
        @click="changeLanguage(code)"
      >
        <b>{{ code }}</b>
        {{ language }}
      </div>
    </div>
  </div>
</template>

<script>
import UrlParams from "@libs/util/url_params.js";
import cookie from "js-cookie";
// TODO: Переписать v-for, без текущего языка!
export default {
  name: "LanguageSelector",

  data: function() {
    let data = {
      languages: {
        // ru: "Русский",
        en: "English",
        fr: "Français",
        de: "Deutsch",
        // pl: "Polski",
        es: "Español",
        cn: "中文",
      },
    };

    return data;
  },

  computed: {
    getCurrentLanguage: function() {
      return this.$store.state.global.cur_language;
    },
  },

  methods: {
    changeLanguage: function(language_code) {
      let param = UrlParams.get("clientlang");

      this.$store.commit("global/writeCurrentLanguage", language_code);

      cookie.set("cur_language", language_code);

      if (param) {
        window.location.href = `https://wf.my.com/battlepass?clientlang=${language_code}_${language_code}`;
      } else {
        window.location.reload();
      }
    },
  },
};
</script>
